import React from 'react';
import { LogoutButton } from 'components/login';
import sealinkLogo from 'assets/images/sealink-logo.png';
import { useProfile } from 'redux/selectors/organisations';

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ logout }) {
  const profile = useProfile();

  const renderWelcomeMessage = () => {
    if (profile) {
      return (
        <div className="header-welcome-message">
          {profile && `Welcome, ${profile.name}`}
        </div>
      );
    }
    return null;
  };

  return (
    <header>
      <img className="header-logo-sealink" src={sealinkLogo} alt="SeaLink" />
      <div className="header-logo-utilities">
        {renderWelcomeMessage()}
        <LogoutButton />
      </div>
    </header>
  );
}
